// What the main server's profile chose of the web app (RFC-059 §6,
// byj-1wv.114.13): its languages, and its theme, named on the document for
// the theme's tokens (byj-1wv.85) to follow. Told by the login page's
// /v1/auth/providers before anyone signs in, and by /v1/me after.
import { offerLanguages } from "./i18n";

export function applyProfile(p: { locales?: string[]; theme?: string }) {
  offerLanguages(p.locales);
  if (typeof document === "undefined") return;
  if (p.theme) document.documentElement.dataset.profileTheme = p.theme;
  else delete document.documentElement.dataset.profileTheme;
}
